<span matSnackBarLabel>
  {{ data.title }}
</span>
<span matSnackBarActions>
  <button
    mat-button
    matSnackBarAction
    (click)="snackBarRef.dismissWithAction()"
  >
    {{ data.buttonText }}
  </button>
</span>
